// extracted by mini-css-extract-plugin
module.exports = {"surface-wrapper":"_20OSc"};